

export const georgeReviewerReviewHinge = {
  _id: 'georgeReviewerReviewHingeId',
  email: 'george@email.com',
  profileReviewId: 'georgeProfileReviewHingeId',
  reviewerProfileId: 'georgeReviewerProfileId',
  starRating: 5,
  reviewText: 'Thanks so much for the review George! This will really help me!',
  profileReviewedFirstName: 'Kramer',
}

export const jerryReviewerReviewBumble = {
  _id: 'jerryReviewerReviewBumbleId',
  email: 'jerry@email.com',
  profileReviewId: 'jerryProfileReviewBumbleId',
  reviewerProfileId: 'jerryReviewerProfileId',
  starRating: 5,
  reviewText: 'Thanks so much for the review Jerry! This will really help me!',
  profileReviewedFirstName: 'Kramer',
}

export const elaineReviewerReviewTinder = {
  _id: 'elaineReviewerReviewTinderId',
  email: 'elaine@email.com',
  profileReviewId: 'elaineProfileReviewTinderId',
  reviewerProfileId: 'elaineReviewerProfileId',
  starRating: 5,
  reviewText: 'Thanks so much for the review Elaine! This will really help me!',
  profileReviewedFirstName: 'Kramer',
}